import { render, staticRenderFns } from "./ATestimonialpopup.vue?vue&type=template&id=4221bf83"
import script from "./ATestimonialpopup.vue?vue&type=script&lang=js"
export * from "./ATestimonialpopup.vue?vue&type=script&lang=js"
import style0 from "./ATestimonialpopup.vue?vue&type=style&index=0&id=4221bf83&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports